export class OrderMembershipPriceApiModel {
  isAppliedOnOrder: boolean;

  membershipLevel: number;

  membershipCardTypeId: string;

  membershipTotalValue: number;
}
